export const cryptoRandom = () => {
    const array = new Uint32Array(1);
    const max = 2 ** 32;
    return crypto.getRandomValues(array)[0] / max;
};
